/*
 * @Descripttion: 项目人员管理
 * @Date: 2024-12-02 17:12:49
 */
import { route } from './src/router';

const name = 'project-person';

export { name, route };
